module.exports = __webpack_public_path__ + "img/D202311_2.cdb291f8.jpg";